import React from 'react';
import '../../styles/AestheticAnalysis.css';

function AnalysisPageLayout({ title, subtitle, children }) {
  return (
    <div className="aesthetic-page">
      <header className="aesthetic-page-header">
        <div>
          <h1>{title}</h1>
          {subtitle && <p>{subtitle}</p>}
        </div>
      </header>
      <main className="aesthetic-content">{children}</main>
    </div>
  );
}

export default AnalysisPageLayout;
